(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('AddCondition', AddCondition);

    AddCondition.$inject = ['$resource'];

    function AddCondition ($resource) {
        var resourceUrl =  'api/add-conditions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
